module.exports = __webpack_public_path__ + "img/face_shape_female_heart_mask.fa665610.png";